import { ModalMessage } from './../../types/modalmessage';
import { ActionMap } from './../../services/action-handler.service';
import { SLContext } from 'src/app/types/sl-context';
import { MapComponent } from 'src/app/components/map/map.component';
import { thousandSeparatorFormatted } from 'angular-slickgrid';
import { bbox, BBox, point, lineString, centroid } from '@turf/turf';
// @ts-ignore
import { LngLatBounds, LngLat } from '!mapbox-gl';
import { NavEvent, NavEvents } from '../NavEvents';
import { DrawPaneComponent } from 'src/app/components/draw-pane/draw-pane.component';
import { control } from 'leaflet';
import { ActionGroupComponent } from 'src/app/components/action-group/action-group.component';
import { AttributeViewComponent } from 'src/app/components/attribute-view/attribute-view.component';
import { MessageOption } from 'src/app/modal-messager/modal-messager.component';
import { ModalConfirmMsg } from 'src/app/types/modalconfirmmsg';
import { Dict } from 'src/app/types/decorable';

export class EditorAction {
  public static geoWatcher = -1;
  public static Exec(command: string, map: MapComponent, data?: any) {
    switch (command) {
      case 'show':
        EditorAction.ShowEditor(map, data);
        break;
      case 'delete-vertex':
        EditorAction.DeleteVertex(map, data);
        break;
      case 'delete-feature':
        EditorAction.DeleteFeature(map, data);
        break;
      case 'gps-update-vertex':
        EditorAction.GPSVertexUpdate(map, data);
        break;
      case 'gps-add-vertex':
        EditorAction.GPSVertexAdd(map, data);
        break;
      case 'gps-vertex-auto-add':
        EditorAction.GPSVertexAutoAdd(map, data);
        break;
      case 'gps-vertex-auto-update':
        EditorAction.GPSVertexAutoUpdate(map, data);
        break;
      case 'passthru-mouse':
        EditorAction.Passthru(map, data);
        break;
      case 'save-geometry':
        EditorAction.SaveGeometry(map, data);
        break;
      case 'cancel-geometry-edit':
        EditorAction.CancelGeometryEdit(map, data);
        break;
      case 'jump-to-geometry':
        EditorAction.JumpToGeometry(map, data);
        break;
      case 'toggle-snaps':
        EditorAction.ToggleSnaps(map, data);
        break;
    }
  }
  public static RegisterActions(actions: ActionMap): ActionMap {
    actions['editor/show'] = {
      name: 'Show Editor',
      handler: (context: SLContext, ...args: any) => {
        EditorAction.Exec('show', context.map.component);
      },
      keys: {
        key: 'd',
        ctrl: true
      },
      trigger: 'press'
    }
    actions['editor/delete-vertex'] = {
      name: 'Delete selected vertex',
      handler: (context: SLContext, ...args: any) => {
        EditorAction.Exec('delete-vertex', context.map.component);
      },
      keys: {
        key: 'DELETE',
      },
      trigger: 'press'
    }
    actions['editor/delete-feature'] = {
      name: 'Delete current feature',
      handler: (context: SLContext, ...args: any) => {
        EditorAction.Exec('delete-feature', context.map.component);
      },
      keys: {
        key: 'DELETE',
        shift: true
      },
      trigger: 'press'
    }
    actions['editor/gps-update-vertex'] = {
      name: 'Update vertex via GPS',
      handler: (context: SLContext, ...args: any) => {
        EditorAction.Exec('gps-update-vertex', context.map.component);
      }
    }
    actions['editor/gps-add-vertex'] = {
      name: 'Add vertex via GPS',
      handler: (context: SLContext, ...args: any) => {
        EditorAction.Exec('gps-add-vertex', context.map.component);
      }
    }
    actions['editor/gps-vertex-auto-add'] = {
      name: 'Automatically add vertex via GPS when accuracy is good',
      handler: (context: SLContext, ...args: any) => {
        EditorAction.Exec('gps-vertex-auto-add', context.map.component);
      }
    }
    actions['editor/gps-vertex-auto-update'] = {
      name: 'Automatically update vertex via GPS when accuracy is good',
      handler: (context: SLContext, ...args: any) => {
        EditorAction.Exec('gps-vertex-auto-add', context.map.component);
      }
    }
    actions['editor/passthru-mouse'] = {
      name: 'Pass mouse events through the digitizer to the underlying map.',
      handler: (context: SLContext, ...args: any) => {
        EditorAction.Exec('passthru-mouse', context.map.component);
      }
    }
    actions['editor/save-geometry'] = {
      name: 'Save current geometry',
      handler: (context: SLContext, ...args: any) => {
        EditorAction.Exec('save-geometry', context.map.component);
      }
    }
    actions['editor/cancel-geometry-edit'] = {
      name: 'Cancel editing the current geometry',
      handler: (context: SLContext, ...args: any) => {
        EditorAction.Exec('cancel-geometry-edit', context.map.component);
      }
    }
    actions['editor/jump-to-geometry'] = {
      name: 'Cancel editing the current geometry',
      handler: (context: SLContext, ...args: any) => {
        EditorAction.Exec('jump-to-geometry', context.map.component);
      }
    }
    actions['editor/toggle-snaps'] = {
      name: 'Toggle snap mode',
      handler: (context: SLContext, ...args: any) => {
        EditorAction.Exec('toggle-snap', context.map.component, args);
      }
    },
      actions['editor/new-feature'] = {
        name: 'New Feature',
        handler: (context: SLContext, ...args: any) => {
          EditorAction.NewEditorFeature(context.map.component, args);
        }
      }

    return actions;
  }
  public static NewEditorFeature(map: MapComponent, data: any) {
    const options = [{ label: 'New Feature', name: 'new' }];
    options.push({ label: 'New Feature - Keep Attributes', name: 'new_attr' });
    if (data?.hasGeometry) {
      options.push({ label: 'New Feature - Keep Geometry', name: 'new_geom' }),
        options.push({ label: 'New Feature - Keep Both', name: 'new_both' });
    }
    if (data.asNew === true) {
      const dig = map.drawPane;
      dig.Clear(true).NewFeature();
      (map.SLMap.src.attributeView as AttributeViewComponent).attEditor.Reset(true);
      const wasDisplayed = map.SLMap.src.secondaryViews.displayedView === 'attribute';
      const wasOpen = map.SLMap.src.attributeView.GoToAttributeEditor();

      //  (map.SLMap.src.attributeView as AttributeViewComponent).Reset();
      if (!wasDisplayed || !wasOpen) {
        this.ShowEditor(map, { edit: 'geom' });
      }
      return;
    }
    map.SLMap.messager.Confirm('This action will clear any geometry and data entered for the current feature and will begin editing a new feature. Click an option below to continue or Cancel to return to your current feature',
      (messageData: Dict) => {
        const dig = map.drawPane;

        switch (messageData.option.name) {
          case 'new':
            dig.Clear(true).NewFeature();
            (map.SLMap.src.attributeView as AttributeViewComponent).attEditor.Reset(false);
            break;
          case 'new_attr':
            dig.Clear(true).NewFeature();
            (map.SLMap.src.attributeView as AttributeViewComponent).attEditor.Reset(true);
            break;
          case 'new_geom':
            (map.SLMap.src.attributeView as AttributeViewComponent).attEditor.Reset(false);
            break;
          case 'new_both':
            (map.SLMap.src.attributeView as AttributeViewComponent).attEditor.Reset(true);
            break;
        }
        const wasDisplayed = map.SLMap.src.secondaryViews.displayedView === 'attribute';
        const wasOpen = map.SLMap.src.attributeView.GoToAttributeEditor();

        //  (map.SLMap.src.attributeView as AttributeViewComponent).Reset();
        if (!wasDisplayed || !wasOpen) {
          this.ShowEditor(map, { edit: 'geom' });
        }



      }, () => { }, 'Create a New Feature', options);


  }
  public static ShowEditor(map: MapComponent, data: any) {
    map.SLMap.src.panelSet.OpenSecondary();
    const wasDisplayed = map.SLMap.src.secondaryViews.displayedView === 'attribute';


    if (map.SLMap.src.secondaryViews.displayedView !== 'attribute') {
      map.SLMap.src.secondaryViews.SetView('attribute');
    }
    if (data === undefined) {
      data = { edit: 'geom' }
    }
    if (!!data && !!data.edit) {
      switch (data.edit) {
        case 'attributes':
          {
            const wasOpen = map.SLMap.src.attributeView.GoToAttributeEditor();
            if (!wasDisplayed || !wasOpen) {
              map.SLMap.src.attributeView.ToggleOpen();
            }
          }
          break;
        default:
        case 'geom':
          {
            const wasOpen = map.SLMap.src.attributeView.GoToGeomEditor();
            if (!wasDisplayed && !wasOpen) {
              map.SLMap.src.attributeView.ToggleOpen();
            }
          }
          if (map.SLMap.src.attributeView?.geometry?.length != 0) {
            map.SLMap.src.attributeView.Refresh(true);
          }
          break;
      }
    }
    const actionGroup: ActionGroupComponent = map.SLMap.src.GetActionGroup('Map Data');
    actionGroup.SetSelected('Editor', true);
    map.ToggleInteraction('digitizing', !!map.SLMap.src.attributeView.digitizerLayer);
    map.SetInfoMode('navigating');
    if (map.SLMap.src.UpdateQueryButtons) {
      map.SLMap.src.UpdateQueryButtons();
    }

    /* for (const button of buttons) {
      if (button.title.toLowerCase() === 'editor') {
        button.classList.toggle('btn-secondary', false);
        button.classList.toggle('btn-primary', true);
      }
    } */
    const wasOpen = map.SLMap.src.attributeView.GoToAttributeEditor();

    if (wasDisplayed && wasOpen) {
      map.SLMap.src.attributeView.ToggleOpen();
    }
    // map.SLMap.src.attributeView.Reset();
  }
  public static CloseEditor(map: MapComponent, data: any) {
    const actionGroup: ActionGroupComponent = map.SLMap.src.GetActionGroup('Map Data');
    actionGroup.SetSelected('Editor', false);
    map.SLMap.src.SetSecondaryView('attribute', false);
    map.SLMap.src.panelSet.UpdatePanels();

  }


  public static DeleteVertex(map: MapComponent, data: any) {
    const dig = map.drawPane;
    dig.DeleteVertex();
  }

  public static DeleteFeature(map: MapComponent, data: any) {
    const dig = map.drawPane;
    map.SLMap.messager.Confirm('Clear the current geometry?',
      () => {
        dig.Clear(true).NewFeature(true);
      }, () => { }, 'Are you sure?');
  }
  public static GPSVertexUpdate(map: MapComponent, data) {
    const drawPane = map.drawPane;
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        drawPane.UpdateFromGPS(position);
      });

    }
  }
  public static GPSVertexAdd(map: MapComponent, data) {
    const drawPane: DrawPaneComponent = map.drawPane;
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        drawPane.AddFromGPS(position);
      });

    }
  }
  public static GPSVertexAutoAdd(map: MapComponent, data) {
    const drawPane = map.drawPane;
    if (EditorAction.geoWatcher !== -1) {
      EditorAction.StopGPS(map, data);
      return;
    }
    map.SLMap.src.StartGPS();
    EditorAction.geoWatcher = navigator.geolocation.watchPosition((position) => {
      this.GPSAutoOrientAction(map, position);
      if (position.coords.accuracy < 10) {
        drawPane.AddFromGPS(position);
      }

    }, (error) => {
      switch (error.code) {
        case error.PERMISSION_DENIED:
        case error.POSITION_UNAVAILABLE:
        case error.TIMEOUT:
          break;

      }
    });
  }
  public static GPSVertexAutoUpdate(map: MapComponent, data) {
    const drawPane = map.drawPane;
    if (EditorAction.geoWatcher !== -1) {
      EditorAction.StopGPS(map, data);
      return;
    }
    map.SLMap.src.StartGPS();
    EditorAction.geoWatcher = navigator.geolocation.watchPosition((position) => {
      this.GPSAutoOrientAction(map, position);
      if (position.coords.accuracy < 10) {
        drawPane.UpdateFromGPS(position, true);
      }
    }, (error) => {
      switch (error.code) {
        case error.PERMISSION_DENIED:
        case error.POSITION_UNAVAILABLE:
        case error.TIMEOUT:
          break;

      }
    });
  }
  static StopGPS(map: MapComponent, data) {
    if (EditorAction.geoWatcher !== -1) {
      navigator.geolocation.clearWatch(EditorAction.geoWatcher);
      EditorAction.geoWatcher = -1;
      map.SLMap.src.StopGPS();
    }
  }
  public static Passthru(map: MapComponent, data: any) {
    if (data.selected === false) {
      map.drawPane.TurnOn();
    } else {
      map.drawPane.TurnOff(false);
    }

  }
  public static SetupButtons(map: MapComponent) {

  }
  public static CancelGeometryEdit(map: MapComponent, data: any) {
    map.drawPane.Cancel();
  }
  public static SaveGeometry(map: MapComponent, data: any) {
    map.drawPane.SaveFeature();
  }
  public static JumpToGeometry(map: MapComponent, data?: any) {
    let geom;
    if (!data) {
      const feature = map.drawPane.GetSelectedFeature();
      if (!feature) {
        return;
      }
      const selection = feature.GetSelectedInfo();
      if (!selection) {
        return;
      }
      data = selection;
    }
    switch (data.type) {
      case 'point':
        map.SLMap.ui.setCenter(new LngLat(data.coord.spatial.lng, data.coord.spatial.lat as number));
        map.SLMap.ui.setZoom(19);
        break;
      case 'segment':
        geom = lineString([[data.from.coord.spatial.lng, data.from.coord.spatial.lat], [data.to.coord.spatial.lng, data.to.coord.spatial.lat]])
        const center = centroid(geom);
        map.SLMap.ui.jumpTo({ center: new LngLat(center.geometry.coordinates[0], center.geometry.coordinates[1]) });
        break;
    }

  }
  public static GPSAutoOrientAction(map: MapComponent, info: any) {
    if (EditorAction.geoWatcher === -1) { return; }
    map.SLMap.historyNaving = false;
    const event: NavEvent = NavEvents.New('navigation/gps-auto-orient');
    map.SLMap.ui.setCenter(new LngLat(info.coords.longitude, info.coords.latitude), event);
    map.SLMap.ui.setZoom(19, event);
    if (info.coords.heading) {
      // map.SLMap.ui.setBearing(info.coords.heading, event);
    }
    map.SLMap.src.GPSUpdate(info.coords, 'editor');


  }
  public static ToggleSnaps(map: MapComponent, info: any) {
    let state = !map.drawPane.isSnapOn;
    if (info.hasOwnProperty('state')) state = info.state;
    switch (state) {
      case true:
        map.drawPane.SnapOn();
        break;
      case false:
        map.drawPane.SnapOff();
        break;
    }
    return

  }
  public static ResetEditor(map: MapComponent, _info: any) {
    (map.SLMap.src.attributeView as AttributeViewComponent).attEditor.Reset();
  }
}
